import React, { useState } from "react";
import toast from "react-hot-toast";
import { Col, Button, Form, Input, Label, Row, Card } from "reactstrap";

const DetailForm = () => {
  const handleSubmit = () => {
    toast.success("Contact Information Submitted Successfully!");
  };
  return (
    <Card>
      <Form>
        <h5 className="card-title pt-3 mx-4 border-bottom fs-16 fw-bold border-bottom">
          Contact Us
        </h5>
        <Row className="pt-3 mx-2 mt-2">
          <Col lg={6}>
            <div className="mb-3">
              <Label htmlFor="firstnameInput" className="form-label">
                Full Name
              </Label>
              <Input
                type="text"
                className="form-control"
                id="firstnameInput"
                placeholder="Enter your firstname"
                // defaultValue="John Doe"
                // readOnly
              />
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <Label htmlFor="lastnameInput" className="form-label">
                Email
              </Label>
              <Input
                type="email"
                className="form-control"
                id="phonenumberInput"
                placeholder="Enter your EmailAddress"
                // defaultValue="dave@12gmail.com"
                // readOnly
              />
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <Label htmlFor="phonenumberInput" className="form-label">
                Phone Number
              </Label>
              <Input
                type="text"
                className="form-control"
                id="phonenumberInput"
                placeholder="Enter your phone number"
                // defaultValue="+(1) 987 6543"
                readOnly
              />
            </div>
          </Col>
          {/* <Col lg={6}>
            <div className="mb-3">
              <Label htmlFor="emailInput" className="form-label">
                Website
              </Label>
              <Input
                type="email"
                className="form-control"
                id="emailInput"
                placeholder="Enter your email"
                defaultValue="daveadame@velzon.com"
              />
            </div>
          </Col> */}
          <Col lg={12}>
            <div className="mb-3">
              <Label htmlFor="phonenumberInput" className="form-label">
                Message
              </Label>
              <Input
                type="textarea"
                className="form-control"
                id="phonenumberInput" // Make sure this matches the 'for' attribute in the Label
                placeholder="Enter message"
                // defaultValue="Hi I'm Anna Adame, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family."
              />
            </div>
          </Col>

          <Col>
            <div className="text-end mb-3">
              <Button
                style={{
                  width: "250px",
                }}
                type="button"
                className="btn btn-success"
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default DetailForm;
